type VerticalBox = { top: number; bottom: number };

/** True when the user's request sits fully above or below the message pane. */
export function isRequestOutsideViewport(
  request: VerticalBox | null,
  viewport: VerticalBox | null,
): boolean {
  if (!request || !viewport) return false;
  if (viewport.bottom <= viewport.top) return false;
  return request.bottom <= viewport.top || request.top >= viewport.bottom;
}

export function isLatestRequestOutsideViewport(container: HTMLElement | null): boolean {
  if (!container) return false;
  const request = container.querySelector<HTMLElement>('[data-chat-request="latest"]');
  if (!request) return false;
  return isRequestOutsideViewport(request.getBoundingClientRect(), container.getBoundingClientRect());
}

/** True when more of the thread sits below the message pane. */
export function isAwayFromBottom(container: HTMLElement | null, threshold = 48): boolean {
  if (!container || container.clientHeight <= 0) return false;
  return container.scrollTop + container.clientHeight < container.scrollHeight - threshold;
}
